import React from 'react'
import Component from 'react-component-component'
import Session from 'components/Session'
import Location from 'components/Location'
import urlForProvider from 'utils/urlForProvider'
import withQueryParams from 'components/withQueryParams'
import withCookieAcceptance from 'components/withCookieAcceptance'
import LoginForm from './components/LoginForm'
import AuthenticatedRedirect from 'components/AuthenticatedRedirect'
import { withTheme, withNotifier } from 'stylist'
import { authenticate, clearError } from 'redux-simple-auth'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { hasAuthorizationParams } from 'utils/auth'
import { Redirect } from 'react-router-dom'

const RouteLoginIndex = ({
  cookiesAccepted,
  clearError,
  query,
  theme,
  match: { path },
  ...rest
}) => (
  <Component
    initialState={{
      matchedSsoProvider: null,
      uri2FA: null,
      redirectToSsoProvider: false
    }}
    willUnmount={clearError}
    render={({
      state: { matchedSsoProvider, redirectToSsoProvider, twoFAEnabled = false, uri2FA, code },
      setState
    }) => (
      <Session
        render={({ hasFailedAuth, lastError, isAuthenticated }) =>
          matchedSsoProvider && redirectToSsoProvider && cookiesAccepted ? (
            <Location to={urlForProvider(matchedSsoProvider.id)} replace />
          ) : isAuthenticated && hasAuthorizationParams(query) ? (
            <Location
              to={`${process.env.REACT_APP_API_HOST}/oauth/authorize?${query}`}
              replace
            />
          ) : isAuthenticated ? (
            <AuthenticatedRedirect query={query} />
          ) : hasFailedAuth &&
          lastError &&
          lastError.error === 'unconfirmed_user' ? (
            <Redirect to={`${path}/confirmation`} push />
          ) : hasFailedAuth &&
          lastError &&
          lastError.error === 'password_expired' ? (
            <Redirect
              to={`${path}/reset-password?reset_password_token=${encodeURIComponent(
                lastError.reset_password_token
              )}&email=${encodeURIComponent(lastError.email)}`}
              push
            />
          ) : (
            <LoginForm
              query={query}
              matchedSsoProvider={matchedSsoProvider}
              uri2FA={uri2FA}
              setState={setState}
              code={code}
              path={path}
              twoFAEnabled={twoFAEnabled}
              cookiesAccepted={cookiesAccepted}
              {...rest}
            />
          )
        }
      />
    )}
  />
)

export default compose(
  connect(
    null,
    { authenticate, clearError }
  ),
  withNotifier,
  withQueryParams,
  withCookieAcceptance
)(withTheme(RouteLoginIndex))



// WEBPACK FOOTER //
// ./src/routes/login/index.js